namespace Areas.Analysis.Index {
    "use strict";

    var staffInfoTabItems = Areas.createTabsWithSameActionAndDifferentAreas("Index",
        [
            "Analysis/Staff",
            "Analysis/Contact",
            "Analysis/EmployeeWeb",
            "Analysis/UcpDownload",
            "Personnel/Map"
        ]);

    export function staffInfoTabInitialized(params: any) {
        return Areas.tabInitialized(staffInfoTabItems)(params);
    }
}